import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import { partnerOrganizationDailyTargetReachedSql } from "@shared/helpers/daily-volunteer-target";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { SqlDatabase } from "remult";
import { PartnerOrganization } from "./entity";

const createCustomFilter = createCustomFilterForEntity<PartnerOrganization>();

export class PartnerOrganizationFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<PartnerOrganization>
  >((filters) => filterWithRelationsAndJson(PartnerOrganization)(filters));

  static dailyVolunteerTargetState = createCustomFilter<{
    state: "has" | "reached" | "open";
  }>(({ state }) => {
    return SqlDatabase.rawFilter(async (build) => {
      const hasTarget = `"partner-organization"."daily_volunteer_target" IS NOT NULL`;
      const reached = partnerOrganizationDailyTargetReachedSql();
      if (state === "has") build.sql = `(${hasTarget})`;
      else if (state === "reached") build.sql = reached;
      else build.sql = `(${hasTarget} AND NOT ${reached})`;
    });
  });
}
